import React from 'react';
import './Social_icon.css';

const Social_icons = (props) => {
  return ( 
    <div className='social_circle'>
        <img className='social_icon' src={props.image} alt="" />
    </div>
  );
}
export default Social_icons;